
import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cajaChicaSolicitudService {

    /******* QUERIES ******/



    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorIdEmpleado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/empleado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    
    async GetSaldoCajaChicaPorId(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/saldo?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async Getcorrelativo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/correlativo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-chica-solicitud/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-chica-solicitud`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica-solicitud`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async aprobar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica-solicitud/aprobar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-chica-solicitud/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new cajaChicaSolicitudService();